import axios from 'axios'
import VueApexCharts from 'vue3-apexcharts'

export default {
  name: 'ClinicalSafetyDashboard',
  components: { apexchart: VueApexCharts },
  data() {
    return {
      basetestUrl: process.env.VUE_APP_Service_URL,
      data: [],

      // metrics
      totalOpenAEs: 0,
      openAEPct:    0,
      saeRate:      0,
      atRiskPct:    0,

      // detail‐view
      selectedTab: 'all',

      // line chart
      lineOptions: {
        chart:  { toolbar: { show: false } },
        stroke: { curve: 'smooth' },
        markers:{ size: 4 },
        yaxis:  { title: { text: 'SAE Count' } },
        xaxis:  { categories: [] }
      },
      lineSeries: [ { name: 'SAEs', data: [] } ],

      // donut chart
      donutOptions: {
        chart: { 
          type: 'donut',
          toolbar: { show: false },
          redrawOnParentResize: true,
          redrawOnWindowResize: true,
         },
        labels: [],
        legend: { position: 'bottom' },
        responsive: []
      },
      donutSeries: ["Good", "Average", "Poor", "Unknown"],

      // site summary
      siteData: [0,0,0,0]
    }
  },
  computed: {
    // rows for the detail table based on selectedTab
    filteredRows() {
      if (this.selectedTab === 'all') return this.data
      const criticalSites = this.siteData
        .filter(s => s.statusClass === 'critical')
        .map(s => s.name)
      return this.data.filter(r => criticalSites.includes(r.SITEID))
    }
  },
  async mounted() {
  await this.getData()
  this._observer = new ResizeObserver(() => {
    const chartCmp = this.$refs.mhstatChart
    if (chartCmp && chartCmp.chart) {
      chartCmp.chart.reflow()
    }
  })
  this._observer.observe(this.$refs.donutWrapper)
},
 beforeUnmount() {
  if (this._observer) {
    this._observer.disconnect();
  }
},
  methods: {
     _onWindowResize() {
    const w = Math.floor(this.$refs.donutWrapper.getBoundingClientRect().width);
    this.$refs.mhstatChart.chart.updateOptions({ chart: { width: w } }, true);
  },
    async getData() {
      try {
        const { data: res } = await axios.post(
          `${this.basetestUrl}/forms-ml/report/getfilteredreports?table_name=AdverseEvents`
        )

        // strip Mongo `_id`
        this.data = res.map(item =>
          Object.fromEntries(
            Object.entries(item).filter(([k]) => k !== '_id')
          )
        )

        const total = this.data.length

        // 1) Total Open AEs & %
        const openCount = this.data.filter(r =>
          String(r.AEYN).toLowerCase() === 'yes'
        ).length
        this.totalOpenAEs = openCount
        this.openAEPct    = total ? Math.round(openCount / total * 100) : 0

        // 2) SAE Rate
        const saeCount = this.data.filter(r =>
          String(r.AESER).toLowerCase() === 'yes'
        ).length
        this.saeRate = total ? Math.round(saeCount / total * 100) : 0

        // 3) Site summary & At-Risk %
        const stats = this.data.reduce((acc, r) => {
          const site = r.SITEID || 'Unknown'
          acc[site] = acc[site] || { AEs: 0, SAEs: 0 }
          acc[site].AEs++
          if (String(r.AESER).toLowerCase() === 'yes') acc[site].SAEs++
          return acc
        }, {})
        this.siteData = Object.entries(stats).map(([name, { AEs, SAEs }]) => {
          const pct = AEs ? SAEs / AEs * 100 : 0
          const statusClass = pct > 30 ? 'critical' : (pct > 0 ? 'warning' : 'good')
          const status = statusClass.charAt(0).toUpperCase() +
                         statusClass.slice(1)
          return { name, AEs, SAEs, status, statusClass }
        })
        const criticalCount = this.siteData.filter(s => s.statusClass === 'critical').length
        this.atRiskPct = this.siteData.length
          ? Math.round(criticalCount / this.siteData.length * 100)
          : 0

        // 4) MHSTAT Donut
        const mhCounts = this.data.reduce((acc, r) => {
          const k = r.MHSTAT || 'Unknown'
          acc[k] = (acc[k] || 0) + 1
          return acc
        }, {})
        this.donutOptions = {
          ...this.donutOptions,
          labels: Object.keys(mhCounts)
        }
        this.donutSeries = Object.values(mhCounts)

        // 5) SAE Trend Line (by month of AESTDTC)
        const monthCounts = this.data
          .filter(r => String(r.AESER).toLowerCase() === 'yes' && r.AESTDTC)
          .reduce((acc, r) => {
            const dt = new Date(r.AESTDTC)
            const label = dt.toLocaleString('default', { month: 'short', year:'numeric' })
            acc[label] = (acc[label] || 0) + 1
            return acc
          }, {})
        const months = Object.keys(monthCounts).sort(
          (a, b) => new Date(a) - new Date(b)
        )
        this.lineOptions = {
          ...this.lineOptions,
          xaxis: { categories: months }
        }
        this.lineSeries = [
          { name: 'SAEs', data: months.map(m => monthCounts[m]) }
        ]
      }
      catch (err) {
        console.error('Error loading AE data', err)
      }
    },
    onInvestigate() { /* … */ },
    onDismiss()    { /* … */ }
  }
}